export class IdIsimDto {

  id: number;
  isim: string;
  talepSeri: string;
  teslimatAdresi: string;
  satinAlmaMailAdresi: string;
  siparisOlusturulduMailAdresi: string;
  telefon: string;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

}
